import React from 'react'
import TopBar from '../Home/Mainhomeone/Topbar'
import Header from '../Globle/Header1'
import Navigation from '../Home/Mainhomeone/Navigation'
import Breadcrumb from '../Globle/Breadecrumb'
import Checkout from '../MainCheckout/Checkout'
import Footer1 from '../Globle/Footer1'

const Main = () => {
    return (
        <>
            <TopBar />
            <Header />
            <Navigation />
            <Breadcrumb title='Checkout' />
            <Checkout />
            <Footer1 />
        </>
    )
}

export default Main
